import map from 'lodash/map';
import pick from 'lodash/pick';
import get from 'lodash/get';
import partial from 'lodash/partial';
import { createSelector } from 'reselect';


export function getChannelIds(state) {
  return state.channels.ids;
}

export function getChannelById(state, channelId) {
  return state.entities.channels[channelId];
}

export function isFetchingChannels(state) {
  return state.channels.activeRequests !== 0;
}


/**
 * @param state
 * @returns {Object[]} channels list
 */
export const getChannels = createSelector(
  [
    state => state,
    getChannelIds,
  ],
  (state, ids) =>
    map(ids, partial(getChannelById, state)),
);


export const getAllChannelsGroupedByIds = state => state.entities.channels;


/**
 * @param state
 * @returns {Object} {id: channel}
 */
export const getChannelsGroupedByIds = createSelector(
  [
    getAllChannelsGroupedByIds,
    getChannelIds,
  ],
  pick,
);


/**
 * @param state
 * @returns {Object} channel
 */
export const getChannelForWidget = createSelector(
  [
    ({ channelInfo }) => get(channelInfo, 'info'),
    ({ channelInfo }) => get(channelInfo, 'paymentInfo'),
  ],
  (info, paymentInfo) => {
    if (!info && !paymentInfo) {
      return null;
    }
    return {
      ...info,
      ...paymentInfo,
    };
  },
);

/**
 * @param state
 * @returns {Object} dgs info
 */
export const getDGSInfo = createSelector(
  [getChannelForWidget],
  ({ dgsInfo }) => dgsInfo,
);

/**
 * @param state
 * @returns {Object} deal info
 */
export const getDealInfo = createSelector(
  [getChannelForWidget],
  ({ dealInfo }) => dealInfo,
);



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/common/selectors/channels.js